export default __webpack_public_path__ + "static/media/tokenImage.a8528625.svg";